export default __webpack_public_path__ + "static/media/share.9aabbb45.svg";